export var Variants;
(function (Variants) {
    Variants["TOUR_OPERATOR"] = "TOUR_OPERATOR";
    Variants["DEPARTURE_DATE"] = "DEPARTURE_DATE";
    Variants["DEPARTURE_WEEKDAY"] = "DEPARTURE_WEEKDAY";
    Variants["DEPARTURE_MONTH"] = "DEPARTURE_MONTH";
    Variants["LENGTH_OF_STAY"] = "LENGTH_OF_STAY";
    Variants["DEPARTURE_AIRPORT"] = "DEPARTURE_AIRPORT";
    Variants["ARRIVAL_AIRPORT"] = "ARRIVAL_AIRPORT";
    Variants["AIRLINE"] = "AIRLINE";
    Variants["HOTEL_ID"] = "HOTEL_ID";
    Variants["HOTEL_BOOKING_CODE"] = "HOTEL_BOOKING_CODE";
    Variants["HOTEL_ROOM_CODE"] = "HOTEL_ROOM_CODE";
    Variants["HOTEL_ROOM_VIEW_COMBI_CODE"] = "HOTEL_ROOM_VIEW_COMBI_CODE";
    Variants["HOTEL_ROOM_BOOKING_CODE"] = "HOTEL_ROOM_BOOKING_CODE";
    Variants["HOTEL_BOARD_CODE"] = "HOTEL_BOARD_CODE";
})(Variants || (Variants = {}));
export default Variants;
